
const CREW_MEMBER_CLASS_CHOICES = {
    J: 'Journeyman',
    Y: 'Yard',
    A_1: 'A1',
    A_2: 'A2',
    A_3: 'A3',
    A_4: 'A4',
    A_5: 'A5',
    A_6: 'A6',
    A_7: 'A7',
    A_8: 'A8',
    F: 'Foreman',
    S: 'Superintendent',
    A: 'Admin',
    C: 'Clerk',
}

export function createCrewMemberProfile(crewMember) {

    return {
        ...crewMember,
        classification: CREW_MEMBER_CLASS_CHOICES[crewMember.classification],
        address: crewMember.street1 ? [`${crewMember.street1} ${crewMember.street2}`, `${crewMember.city}, ${crewMember.state} ${crewMember.zipcode}`] : null
    }
}